export var multiAction = function (actions) {
    return function (dispatch) { return actions.map(function (a) { return dispatch(a); }); };
};
